export default __webpack_public_path__ + "static/media/LOGO-HOMTICK.37d07512.png";